import React from 'react';
import Postponement from './components/postponement/Postponement';
import PostponementTeleporada from './components/postponementTeleporada/PostponementTeleporada';

export default function PostponementApp() {
    // Get the flag from the global object populated by wp_localize_script
    const isTeleporada = (window as any).postponementFormVars?.isTeleporada || false;

    if (isTeleporada) {
        return <PostponementTeleporada />;
    }

    return <Postponement />;
}
